import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="pt-16 md:pt-[72px] flex flex-col items-center justify-center min-h-[70vh] text-center px-5">
      <span className="flex items-center justify-center w-20 h-20 rounded-full bg-background-100 text-foreground-300 mb-6">
        <i className="ri-emotion-sad-line text-4xl" />
      </span>
      <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-3">
        页面走丢了
      </h1>
      <p className="text-sm md:text-base text-foreground-500 mb-2 max-w-md">
        你访问的地址可能已被移除或输入有误，试试从下面的入口继续浏览。
      </p>
      <p className="text-xs text-foreground-400 font-mono mb-8 break-all">{location.pathname}</p>
      <div className="flex flex-col sm:flex-row items-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/works"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-medium bg-accent-500 text-primary-950 hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-grid-line" />
          浏览影视作品
        </Link>
      </div>
    </div>
  );
}